export default __webpack_public_path__ + "static/media/BLR19.fc6b9a4d.jpg";